import { FilterId } from '../types/filters/filters';
import { Listing } from '../types/sharetribe/listing';
import { getLabel } from '../util/helpers';
import { findOptionsForSelectFilter } from '../util/search';
import { useShopConfigV2 } from './shopConfig';

export const useListingConditionLabel = (listing: Listing) => {
  const condition = listing.attributes.publicData?.condition;

  const { filters } = useShopConfigV2();
  const conditionOptions = findOptionsForSelectFilter(FilterId.Condition, filters);

  const conditionLabel = getLabel(conditionOptions, condition);

  return { conditionLabel };
};
